import React from "react";
const CheckIcon: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" width="24px" height="24px" color="#1E2F56"><path d="M20.25 6.75047L9.75 17.25L4.5 12.0005" stroke="currentcolor" strokeLinecap="round" stroke-linejoin="round"></path></svg>
  );
};

export default CheckIcon;
